import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, SOCIAL_LINKS, SERVICES } from '../../utils/constants';
import Arrow from '../Arrow/Arrow';

function ContactIcon({type}) {
  const common={viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:"1.7",strokeLinecap:"round",strokeLinejoin:"round", "aria-hidden":"true"};
  if(type==='mail') return <svg className="contact-icon" {...common}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>;
  if(type==='phone') return <svg className="contact-icon" {...common}><path d="M7.2 3.5 10 6.3 8.2 9.1c1.1 2.2 2.7 3.8 4.9 4.9l2.8-1.8 2.8 2.8-1.6 3.1c-.4.8-1.3 1.2-2.1 1C8.8 18 6 15.2 4.9 8.9c-.2-.9.2-1.7 1-2.1l1.3-3.3Z"/></svg>;
  return <svg className="contact-icon" {...common}><path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12Z"/><circle cx="12" cy="9" r="2.3"/></svg>;
}

export default function Footer() {
  return <footer className="footer">
    <div className="container footer-grid">
      <div className="footer-brand">
        <Link to="/" className="footer-logo" aria-label="Afrikkom Global home"><img src="/optimized-images/logo.webp" alt="Afrikkom Global" width="180" height="70" loading="lazy" decoding="async"/></Link>
        <p>Build. Connect. Grow.</p>
        <span>Software-led technology, telecom engineering and practical business support for a connected world.</span>
      </div>
      <div className="footer-col"><h4>Explore</h4><Link to="/">Home</Link><Link to="/about-us">About</Link><Link to="/services">Services</Link><Link to="/portfolio">Projects</Link></div>
      <div className="footer-col"><h4>Capabilities</h4>{SERVICES.map(s=><Link key={s.id} to={`/services/${s.slug}`}>{s.short}</Link>)}<Link to="/careers">Careers</Link></div>
      <div className="footer-col footer-contact">
        <h4>Connect</h4>
        <a className="contact-row" href={`mailto:${COMPANY_INFO.email}`}><ContactIcon type="mail"/><span>{COMPANY_INFO.email}</span></a>
        <a className="contact-row" href={`tel:${COMPANY_INFO.phone.replace(/\s/g,'')}`}><ContactIcon type="phone"/><span>{COMPANY_INFO.phone}</span></a>
        <div className="contact-row address-row"><ContactIcon type="pin"/><span>{COMPANY_INFO.address}</span></div>
        <a className="contact-row" href={SOCIAL_LINKS.linkedin} target="_blank" rel="noreferrer"><span className="linkedin-mark">in</span><span>LinkedIn</span><Arrow/></a>
      </div>
    </div>
    <div className="container footer-bottom"><span>© {new Date().getFullYear()} Afrikkom Global. All rights reserved.</span><span>Software · Telecom · Payroll & Consulting</span></div>
  </footer>;
}
